module.exports = __webpack_public_path__ + "img/consensus.eeef9c9a.png";